<template>
  <v-container class="pa-0">
    <v-data-table
      :headers="headers"
      :items="activeAccount.iovation.items"
      sort-by="created"
      dense
      sort-desc
      calculate-widths
      height="405"
      :loading="activeAccount.iovation.loading"
      hide-default-footer
      :items-per-page="-1"
    />
  </v-container>
</template>

<style>

</style>

<script>
  import { mapGetters } from 'vuex'
  import { API } from '@/utils/api'

  export default {
    props: [],

    data: () => ({
      proofImg: false,
      dialog: false,
      headers: [
        { text: 'Date', value: 'created' },
        { text: 'State', value: 'result' },
        { text: 'Description', align: 'left', sortable: false, value: 'reason' },
        { text: 'TN', value: 'trackingnumber' },
      ]
    }),

    computed: {
      ...mapGetters({ activeAccount: 'account/active' })
    },

    methods: {}

  }
</script>
